// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53c558a2","453":"1cdd05dc","667":"99987789"}[chunkId] + ".chunk.js";
};